import React, { useEffect, useState } from "react";
import Handler from "../../Helpers/Components/Handler";

const TILES = [
    { key: "newToday", label: "New Bookings Today", icon: "fa-solid fa-book-open", tone: "primary" },
    { key: "deliveriesToday", label: "Deliveries Today", icon: "fa-solid fa-truck", tone: "info" },
    { key: "pickupsToday", label: "Pickups Today", icon: "fa-solid fa-arrow-rotate-left", tone: "success" },
    { key: "cancelledToday", label: "Cancelled Today", icon: "fa-solid fa-ban", tone: "danger" }
];

const BookingStats = ({ onQuickFilter }) => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState(null);

    const getStats = async () => {
        setLoading(true);
        const response = await Handler({ method: "get", url: "/booking/stats" });
        if (response?.success) setStats(response?.data);
        else setStats(null);
        setLoading(false);
    };

    useEffect(() => {
        getStats();
    }, []);

    const values = {
        newToday: stats?.today?.newBookings || 0,
        deliveriesToday: stats?.today?.deliveries || 0,
        pickupsToday: stats?.today?.pickups || 0,
        cancelledToday: stats?.today?.cancelled || 0,
        ongoing: stats?.overall?.ongoing || 0,
        totalBookings: stats?.overall?.total || 0,
    };

    return (
        <div className="lead-stats mb-3">
            <div className="lead-stats-grid">
                {TILES.map((tile) => (
                    <div
                        className={`lead-stat-card tone-${tile.tone}${onQuickFilter ? " lead-stat-card-clickable" : ""}`}
                        key={tile.key}
                        role={onQuickFilter ? "button" : undefined}
                        style={onQuickFilter ? { cursor: "pointer" } : undefined}
                        onClick={() => onQuickFilter?.(tile.key)}
                        title={onQuickFilter ? `Filter bookings: ${tile.label}` : undefined}
                    >
                        <div className="lead-stat-icon"><i className={tile.icon}></i></div>
                        <div className="lead-stat-info">
                            <span className="lead-stat-value">{loading ? "-" : values[tile.key]}</span>
                            <span className="lead-stat-label">{tile.label}</span>
                        </div>
                    </div>
                ))}
            </div>
            {!loading && stats?.overall ? (
                <div className="lead-stats-breakdown">
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-primary"></i> Booked: <b>{stats.overall.booked || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-warning"></i> Ongoing: <b>{stats.overall.ongoing || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-info"></i> Pending: <b>{stats.overall.pending || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-success"></i> Completed: <b>{stats.overall.completed || 0}</b></span>
                    <span className="d-flex align-items-center"><i className="fa-solid fa-circle text-danger"></i> Cancelled: <b>{stats.overall.cancelled || 0}</b></span>
                </div>
            ) : null}
        </div>
    );
};

export default BookingStats;
